import { useModal } from '../contexts';
import { useState } from 'react';
import { postData } from '../backend';
import { useHistory } from 'react-router-dom';
import useUser from '../hooks/useUser';
import Modal from './Modal';
import TextInputField from './TextInputField';
import { useTranslation } from "react-i18next";

function CreateTeamModal() {
  const { t } = useTranslation();
  const history = useHistory();

  const { refreshUser } = useUser();
  const { closeModal } = useModal();

  const [teamName, setTeamName] = useState<string>('');

  const [invalid, setInvalid] = useState(false);
  const [saving, setSaving] = useState(false);

  function handleUpdateName(name: string) {
    setInvalid(!name);
    setTeamName(name);
  }

  function handleCreate() {
    if (!teamName)
      return setInvalid(true);

    setSaving(true);
    postData("/auth/team/", { name: teamName })
      .then((team) => {
        setSaving(false);

        refreshUser();
        closeModal(() => history.push("/settings/team"));
      })
      .catch(console.error);
  }

  return (
    <Modal
      title={t("Thank you for signing up to Teams 🎉")}
      subtitle={t("What is the name of your team?")}
      preventClose
      primaryButtonProps={{
        onClick: handleCreate,
        disabled: saving,
        text: saving ? t("Creating Team...") : t("Create Team")
      }}
      size='sm'
    >
      <TextInputField className="w-full mb-2" value={teamName} onChange={handleUpdateName} onEnter={handleCreate} invalid={invalid} />
      <p className="text-sm font-semibold mb-4 text-center">{t("You can change this later in Settings > Team")}</p>
    </Modal>
  );
}

export default CreateTeamModal;
